import { STATUS } from '@features/General'
import { createSlice, PayloadAction } from '@reduxjs/toolkit'

export interface IOneCompanySubscriptionPayload {
    subscriptionId: string
}

export interface IState {
    status: string
    data: any
    errors: any
}

const initialState: IState = {
    status: STATUS.IDLE,
    data: null,
    errors: null
}

const oneCompanySubscription = createSlice({
    name: 'subscriptions/one-company-subscription',
    initialState,
    reducers: {
        onRequest(state, action: PayloadAction<IOneCompanySubscriptionPayload>) {
            state.status = STATUS.RUNNING
        },
        onSuccess(state, action) {
            state.status = STATUS.READY
            state.data = action.payload
        },
        onFailure(state, action) {
            state.status = STATUS.ERROR
            state.errors = action.payload
        }
    }
})

export const oneCompanySubscriptionActions = oneCompanySubscription.actions
export default oneCompanySubscription.reducer
